import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs2/helpers/applyDecoratedDescriptor";

var _dec, _dec2, _class, _class2, _class3, _temp, _dec3, _class4;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind, decorate } from 'core-decorators';
import invariant from 'invariant';
import { styled, StyleSheet, keyframes } from '@rexlabs/styling';
import CSSAnimationGroup from '@rexlabs/css-animation-group';
import VividFile from './file';
import _ from 'lodash';
var enterAnimation = keyframes({
  '0%': {
    transform: 'scale(0)'
  },
  '100%': {
    transform: 'scale(1)'
  }
});
var leaveAnimation = keyframes({
  '0%': {
    transform: 'scale(1)'
  },
  '100%': {
    transform: 'scale(0)'
  }
});
var FileUploadInput = (_dec = styled(StyleSheet({
  inner: {
    position: 'relative',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    flex: '1 0 auto',
    width: '100%',
    height: '100%',
    minHeight: '10rem',
    cursor: 'pointer',
    backgroundColor: 'lightgrey',
    transition: 'background-color 150ms ease-out',
    '&:after': {
      position: 'absolute',
      content: '""',
      top: '-2px',
      left: '-2px',
      bottom: '-2px',
      right: '-2px',
      zIndex: 0
    },
    '& > *': {
      zIndex: 1
    }
  },
  noFileSelected: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    opacity: '1',
    pointerEvents: 'none',
    transition: 'opacity 150ms ease'
  },
  hasItems: {
    opacity: '0'
  },
  isDragging: {
    cursor: 'copy',
    backgroundColor: 'lightsteelblue'
  }
})), _dec2 = decorate(_.memoize), _dec(_class = autobind(_class = (_class2 = (_temp = _class3 =
/*#__PURE__*/
function (_Component) {
  _inherits(FileUploadInput, _Component);

  function FileUploadInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FileUploadInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FileUploadInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDragging: false,
      files: []
    });

    _defineProperty(_assertThisInitialized(_this), "endDragEvents", ['dragleave', 'dragend']);

    return _this;
  }

  _createClass(FileUploadInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          setRemove = _this$props.setRemove,
          setTriggerInput = _this$props.setTriggerInput,
          initialFiles = _this$props.initialFiles;

      if (setRemove !== _.noop || setTriggerInput !== _.noop) {
        console.warn('setRemove and setTriggerInput have been deprecated, please use the children as function implementation instead');
        setRemove(this.handleRemove);
        setTriggerInput(this.handleTriggerInput);
      }

      if (initialFiles) {
        this.addFiles(initialFiles);
      }
    } // Formik expects an object with this shape to be sent to it's
    // onChange handler so this just fakes that object since we can't
    // manipulate the event.target.value on file input events directly

  }, {
    key: "createFakeEvent",
    value: function createFakeEvent(files) {
      var name = this.props.name;
      return {
        persist: _.noop,
        target: {
          type: 'file',
          name: name,
          id: name,
          files: files
        }
      };
    }
  }, {
    key: "isValidFileType",
    value: function isValidFileType(file) {
      var _this$props2 = this.props,
          acceptTypes = _this$props2.acceptTypes,
          acceptExtensions = _this$props2.acceptExtensions,
          onInvalidType = _this$props2.onInvalidType;

      if (acceptTypes === '*' && acceptExtensions === '*') {
        return true;
      }

      if (acceptTypes === '*' || acceptTypes.includes(file.type)) {
        var ext = file.name.slice(file.name.lastIndexOf('.'), file.name.length);

        if (acceptExtensions === '*' || acceptExtensions.includes(ext)) {
          return true;
        }
      }

      onInvalidType(file);
      return false;
    }
  }, {
    key: "isWithinSizeLimit",
    value: function isWithinSizeLimit(file) {
      var _this$props3 = this.props,
          maxFileSize = _this$props3.maxFileSize,
          onInvalidFileSize = _this$props3.onInvalidFileSize; // Convert max file size to bytes then compare

      if (!maxFileSize || file.size <= maxFileSize * 1000) {
        return true;
      }

      onInvalidFileSize(file);
      return false;
    }
  }, {
    key: "addFiles",
    value: function addFiles(files, event) {
      var _this2 = this;

      var _this$props4 = this.props,
          shouldAllowMultiple = _this$props4.shouldAllowMultiple,
          onChange = _this$props4.onChange;

      var newFiles = _.filter(files, function (file) {
        if (!_this2.state.files.find(function (val) {
          return file.name === val.name && file.size === val.size;
        }) && _this2.isValidFileType(file) && _this2.isWithinSizeLimit(file)) {
          return true;
        }
      });

      this.setState({
        isDragging: false,
        files: shouldAllowMultiple ? [].concat(_toConsumableArray(this.state.files), _toConsumableArray(newFiles)) : newFiles.length > 0 ? [newFiles[0]] : this.state.files
      }, function () {
        onChange(_this2.createFakeEvent(_this2.state.files));
      });
    }
  }, {
    key: "clearInput",
    value: function clearInput() {
      this.input.value = '';
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(e) {
      var onDragStart = this.props.onDragStart;
      e.preventDefault();
      e.stopPropagation();
      onDragStart();
      this.setState({
        isDragging: true
      });
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd(e) {
      var onDragEnd = this.props.onDragEnd;
      e.preventDefault();
      e.stopPropagation();
      onDragEnd();
      this.setState({
        isDragging: false
      });
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(e) {
      var onDrop = this.props.onDrop;
      e.preventDefault();
      e.stopPropagation();
      onDrop();
      this.addFiles(e.dataTransfer.files, e);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.addFiles(e.target.files, e);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      var onFocus = this.props.onFocus;
      e.preventDefault();
      onFocus(this.createFakeEvent(this.state.files));
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var onBlur = this.props.onBlur;
      e.preventDefault();
      onBlur(this.createFakeEvent(this.state.files));
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(indices) {
      var _this3 = this;

      var onChange = this.props.onChange;

      if (indices !== undefined) {
        this.setState(function (state) {
          var newState = _objectSpread({}, state, {
            files: _.filter(state.files, function (file, index) {
              return _.isArray(indices) ? !indices.includes(index) : indices !== index;
            })
          });

          return newState;
        }, function () {
          onChange(_this3.createFakeEvent(_this3.state.files));
        });
      } else {
        this.handleClear();
      }

      this.clearInput();
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      var _this4 = this;

      var onChange = this.props.onChange;
      this.setState({
        files: []
      }, function () {
        onChange(_this4.createFakeEvent(_this4.state.files));
      });
    }
  }, {
    key: "handleTriggerInput",
    value: function handleTriggerInput() {
      this.input.click();
    }
  }, {
    key: "getAcceptTypes",
    value: function getAcceptTypes(acceptExtensions, acceptTypes) {
      if (acceptExtensions === '*' && acceptTypes === '*') {
        return undefined;
      }

      var types = acceptTypes === '*' ? [] : acceptTypes;
      var extensions = acceptExtensions === '*' ? [] : acceptExtensions;
      return [].concat(_toConsumableArray(types), _toConsumableArray(extensions)).join(',');
    }
  }, {
    key: "setInputRef",
    value: function setInputRef(ref) {
      this.input = ref;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$state = this.state,
          isDragging = _this$state.isDragging,
          files = _this$state.files;
      var _this$props5 = this.props,
          s = _this$props5.styles,
          name = _this$props5.name,
          tabIndex = _this$props5.tabIndex,
          acceptTypes = _this$props5.acceptTypes,
          acceptExtensions = _this$props5.acceptExtensions,
          shouldAllowMultiple = _this$props5.shouldAllowMultiple,
          showImageThumbnails = _this$props5.showImageThumbnails,
          _this$props5$animatio = _this$props5.animationProps,
          component = _this$props5$animatio.component,
          enterAnimation = _this$props5$animatio.enterAnimation,
          enterDelay = _this$props5$animatio.enterDelay,
          enterDirection = _this$props5$animatio.enterDirection,
          enterDuration = _this$props5$animatio.enterDuration,
          enterFillMode = _this$props5$animatio.enterFillMode,
          enterIterationCount = _this$props5$animatio.enterIterationCount,
          enterTimingFunction = _this$props5$animatio.enterTimingFunction,
          leaveAnimation = _this$props5$animatio.leaveAnimation,
          leaveDelay = _this$props5$animatio.leaveDelay,
          leaveDirection = _this$props5$animatio.leaveDirection,
          leaveDuration = _this$props5$animatio.leaveDuration,
          leaveFillMode = _this$props5$animatio.leaveFillMode,
          leaveIterationCount = _this$props5$animatio.leaveIterationCount,
          leaveTimingFunction = _this$props5$animatio.leaveTimingFunction,
          enterOnAppear = _this$props5$animatio.enterOnAppear,
          VividFile = _this$props5.VividFile,
          Close = _this$props5.Close,
          NoFileSelected = _this$props5.NoFileSelected,
          children = _this$props5.children;
      var accept = this.getAcceptTypes(acceptExtensions, acceptTypes);
      var inputProps = {
        name: name,
        tabIndex: tabIndex,
        shouldAllowMultiple: shouldAllowMultiple,
        accept: accept,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        setInputRef: this.setInputRef
      };
      var dragEvents = {
        onDragEnter: this.handleDragStart,
        onDragOver: this.handleDragOver,
        onDragLeave: this.handleDragEnd,
        onDragEnd: this.handleDragEnd,
        onDrop: this.handleDrop
      };

      if (children && _.isFunction(children)) {
        return children({
          InputContainer: InputContainer,
          inputProps: inputProps,
          dragEvents: dragEvents,
          files: files,
          isDragging: isDragging,
          addFiles: this.addFiles,
          removeFiles: this.handleRemove,
          triggerInput: this.handleTriggerInput
        });
      } else {
        return React.createElement(InputContainer, _extends({}, inputProps, dragEvents), React.createElement(CSSAnimationGroup, _extends({}, s('inner', {
          isDragging: isDragging
        }), {
          component: component,
          enterAnimation: enterAnimation,
          enterDelay: enterDelay,
          enterDirection: enterDirection,
          enterDuration: enterDuration,
          enterFillMode: enterFillMode,
          enterIterationCount: enterIterationCount,
          enterTimingFunction: enterTimingFunction,
          leaveAnimation: leaveAnimation,
          leaveDelay: leaveDelay,
          leaveDirection: leaveDirection,
          leaveDuration: leaveDuration,
          leaveFillMode: leaveFillMode,
          leaveIterationCount: leaveIterationCount,
          leaveTimingFunction: leaveTimingFunction,
          enterOnAppear: enterOnAppear
        }), files.length && files.map(function (file, i) {
          return React.createElement(VividFile, {
            key: "".concat(file.name, "_").concat(file.size),
            file: file,
            index: i,
            handleRemove: _this5.handleRemove,
            isDragging: isDragging,
            showImageThumbnail: showImageThumbnails,
            Close: Close
          });
        })), React.createElement("div", s('noFileSelected', {
          hasItems: files.length > 0
        }), _.isFunction(NoFileSelected) ? React.createElement(NoFileSelected, null) : NoFileSelected));
      }
    }
  }]);

  return FileUploadInput;
}(Component), _defineProperty(_class3, "displayName", 'FileUpload'), _defineProperty(_class3, "defaultProps", {
  shouldAllowMultiple: false,
  showImageThumbnails: true,
  animationProps: {
    enterAnimation: enterAnimation,
    enterDelay: '200ms',
    enterDuration: '180ms',
    enterTimingFunction: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    leaveAnimation: leaveAnimation,
    leaveDuration: '180ms',
    leaveTimingFunction: 'cubic-bezier(0.6, -0.28, 0.735, 0.045)'
  },
  acceptTypes: ['image/png', 'image/svg+xml', 'image/jpg', 'image/jpeg', 'image/bmp'],
  acceptExtensions: ['.png', '.svg', '.jpg', '.jpeg', '.bmp'],
  maxFileSize: 2048,
  onInvalidType: _.noop,
  onInvalidFileSize: _.noop,
  onChange: _.noop,
  onFocus: _.noop,
  onBlur: _.noop,
  onDragStart: _.noop,
  onDragEnd: _.noop,
  onDrop: _.noop,
  setRemove: _.noop,
  setTriggerInput: _.noop,
  Container: 'div',
  VividFile: VividFile,
  Close: 'x',
  NoFileSelected: React.createElement("div", null, 'Drag or click to upload')
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, "getAcceptTypes", [_dec2], _Object$getOwnPropertyDescriptor(_class2.prototype, "getAcceptTypes"), _class2.prototype)), _class2)) || _class) || _class);
FileUploadInput.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  tabIndex: PropTypes.number,
  acceptTypes: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  acceptExtensions: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  maxFileSize: PropTypes.number,
  shouldAllowMultiple: PropTypes.bool,
  showImageThumbnails: PropTypes.bool,
  initialFiles: PropTypes.arrayOf(PropTypes.instanceOf(File)),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onInvalidType: PropTypes.func,
  onInvalidFileSize: PropTypes.func,
  VividFile: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  Close: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  NoFileSelected: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
} : {};
var InputContainer = (_dec3 = styled(StyleSheet({
  container: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    border: '2px dashed grey',
    background: 'transparent'
  },
  input: {
    width: 0.1,
    height: 0.1,
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1
  }
})), _dec3(_class4 =
/*#__PURE__*/
function (_Component2) {
  _inherits(InputContainer, _Component2);

  function InputContainer() {
    _classCallCheck(this, InputContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(InputContainer).apply(this, arguments));
  }

  _createClass(InputContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props6 = this.props,
          onChange = _this$props6.onChange,
          onDrop = _this$props6.onDrop;
      invariant(onChange && onDrop, 'Necessary props missing! Have you spread both \'inputProps\' & \'eventListeners\' onto \'InputContainer\'?');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          s = _this$props7.styles,
          name = _this$props7.name,
          tabIndex = _this$props7.tabIndex,
          shouldAllowMultiple = _this$props7.shouldAllowMultiple,
          accept = _this$props7.accept,
          setInputRef = _this$props7.setInputRef,
          onChange = _this$props7.onChange,
          onFocus = _this$props7.onFocus,
          onBlur = _this$props7.onBlur,
          onDragEnter = _this$props7.onDragEnter,
          onDragOver = _this$props7.onDragOver,
          onDragLeave = _this$props7.onDragLeave,
          onDragEnd = _this$props7.onDragEnd,
          onDrop = _this$props7.onDrop,
          children = _this$props7.children;
      return React.createElement("label", _extends({}, s('container'), {
        htmlFor: name,
        onDragEnter: onDragEnter,
        onDragOver: onDragOver,
        onDragLeave: onDragLeave,
        onDragEnd: onDragEnd,
        onDrop: onDrop
      }), children, React.createElement("input", _extends({}, s('input'), {
        ref: setInputRef,
        type: "file",
        id: name,
        tabIndex: tabIndex,
        multiple: shouldAllowMultiple,
        accept: accept,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur
      })));
    }
  }]);

  return InputContainer;
}(Component)) || _class4);
export default FileUploadInput;